import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { CriterionEvent, SearchCriterion, ICriterionComponent, SearchCriteriaRegistrant } from 'src/app/types/search-criteria';


@Component({
	selector: 'app-text-val',
	templateUrl: './text-val.component.html',
	styleUrls: ['./text-val.component.scss']
})
export class TextValComponent implements OnInit, ICriterionComponent {

	public textValue = '';

	@Input() field = '';
	@Output()
	public registrantReady = new EventEmitter<SearchCriteriaRegistrant>();

	@Input() comparison = '';

	@Input() pattern = '';

	@Output()
	public criteriaChange = new EventEmitter<CriterionEvent>();

	@Output()
	public valueChange = new EventEmitter<string>();

	@Input()
	public get value(): string {
		return this.textValue;
	}

	public set value(val: string) {
		this.textValue = val;
	}

	HandleDateChange() {
		this.valueChange.emit(this.value);
		this.criteriaChange.emit({
			target: this,
			value: this.value,
			criterion: this.ToCriterion()
		});
	}
	constructor() { }

	ngOnInit(): void {
		this.registrantReady.emit({ field: this.field, component: this })
	}

	ToCriterion(field?: string, comparison?: string): SearchCriterion | null {
		if (!field) {
			field = this.field;
			if (field === '') {
				return null;
			}
		}
		if (!comparison) {
			comparison = this.comparison;
			if (comparison === '') {
				return null;
			}
		}

		return {
			compare: (comparison),
			field: (field),
			value: this.value,
			casting: 'text'
		}


	}


}
